module.exports = {"id":"201122","name":"Tomáš Kalas","rating":"72","photo":"./data/images/photos/3/201122.png","club":{"name":"Fulham","logo":"./data/images/clubs/Fulham.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TomasKalas0.json
// module id = 4175
// module chunks = 0